.ownerCommentHistoryUserAndTimestamp,
.buttonContainer {
    justify-content: space-between;
}

.ownerCommentHistoryContainer,
.complianceRequirementsContainer,
.alignVertical {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ownerCommentHistoryUserAndTimestamp,
.buttonContainer,
.alignHorizontal {
    display: flex;
}

.alignHorizontal {
    gap: 20px;
}

.fullWidth {
    width: 100%;
}

/* These values mimic the default styles for <hr /> in order to create a vertical rule that looks the same. */
.verticalRule {
    border: 1px solid #34586b;
    opacity: .25;
}

.ownerCommentHistoryContainer,
.complianceRequirementsContainer,
.fieldContainer {
    margin-bottom: 20px;
}

.fieldMaxWidthRequirement {
    max-width: 260px;
}

.fieldMaxWidthEffectiveness {
    max-width: 300px;
}

.regReqIdPadding {
    padding-left: 20px;
}

.regReqTextPadding {
    padding-left: 40px;
}

.copyButtonTextMargin {
    margin-right: 20px;
}